import cn from "app/util/classnames";

export default function Loader({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "relative aspect-square w-36",
        "animate-[spin_1s_infinite_linear]",
        "rounded-full border-4 border-transparent border-y-neutral-600",
        className,
      )}
    >
      <div
        className={cn(
          "absolute inset-1",
          "animate-[spin_0.5s_reverse_infinite_linear]",
          "rounded-full border-4 border-transparent border-y-white",
        )}
      />
      <div
        className={cn(
          "absolute inset-4",
          "rounded-full border-4 border-transparent border-y-neutral-600",
        )}
      />
    </div>
  );
}
